/* GrokBot 2026-10-17 · Servir & Degustar: tabs, viewport reveal, pairing chips */
(function(){
  function init(root){
    if(root.__vgsv)return;root.__vgsv=1;
    var tabs=[].slice.call(root.querySelectorAll('[role=tab]')),pill=root.querySelector('.vg-sv__pill');
    root.querySelector('.vg-sv__tabs').style.setProperty('--n',tabs.length);
    function sel(i,focus){tabs.forEach(function(t,j){var on=i===j,p=document.getElementById(t.getAttribute('aria-controls'));
      t.setAttribute('aria-selected',on);t.tabIndex=on?0:-1;if(p){p.hidden=!on;p.classList.toggle('is-on',on)}});
      if(pill)pill.style.setProperty('--i',i);if(focus)tabs[i].focus();}
    tabs.forEach(function(t,i){t.addEventListener('click',function(){sel(i)});
      t.addEventListener('keydown',function(e){var k=e.key,n=tabs.length,j=null;
        if(k==='ArrowRight')j=(i+1)%n;else if(k==='ArrowLeft')j=(i-1+n)%n;else if(k==='Home')j=0;else if(k==='End')j=n-1;
        if(j!==null){e.preventDefault();sel(j,true)}})});
    var why=root.querySelector('.vg-sv__why'),chips=[].slice.call(root.querySelectorAll('.vg-sv__chip'));
    chips.forEach(function(c){c.addEventListener('click',function(){var on=c.getAttribute('aria-pressed')!=='true';
      chips.forEach(function(o){o.setAttribute('aria-pressed','false')});
      if(on){c.setAttribute('aria-pressed','true');why.querySelector('[data-why-t]').textContent=c.dataset.why;
        var a=why.querySelector('[data-why-a]');a.href=c.dataset.href;a.textContent=c.dataset.lbl+' →';why.hidden=false;
        why.style.animation='none';void why.offsetWidth;why.style.animation='';}else why.hidden=true;})});
    if(chips[0]&&why){chips[0].click();}
    var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(rm||!('IntersectionObserver'in window)){root.classList.add('is-in');return}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){root.classList.add('is-in');io.disconnect()}})},{threshold:.35});
    io.observe(root);
    // replay fill when switching back to a tab
    tabs.forEach(function(t){t.addEventListener('click',function(){root.classList.remove('is-in');void root.offsetWidth;requestAnimationFrame(function(){root.classList.add('is-in')})})});
  }
  function run(){[].forEach.call(document.querySelectorAll('[data-vg-sv]'),init)}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
})();
